function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 0,
  x2: 431,
  y1: 256,
  y2: 256
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#87f1fc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: .2557,
  stopColor: "#7fd4fb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: .5295,
  stopColor: "#78bcfb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: .7844,
  stopColor: "#74aefa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#73a9fa"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m271 512h-191c-44.113281 0-80-35.886719-80-80v-271c0-44.113281 35.886719-80 80-80h191c44.113281 0 80 35.886719 80 80v271c0 44.113281-35.886719 80-80 80zm-191-391c-22.054688 0-40 17.945312-40 40v271c0 22.054688 17.945312 40 40 40h191c22.054688 0 40-17.945312 40-40v-271c0-22.054688-17.945312-40-40-40zm351 261v-302c0-44.113281-35.886719-80-80-80h-222c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h222c22.054688 0 40 17.945312 40 40v302c0 11.046875 8.953125 20 20 20s20-8.953125 20-20zm0 0",
  fill: "url(#a)"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "512pt",
  viewBox: "-40 0 512 512",
  width: "512pt",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/copy.b50824a6.svg";
export { SvgComponent as ReactComponent };